<div class="header-card">
	<div>
		<span class="title">{{"truck_site_summary_report.title" | translate}}</span>
		<div class="labels">
			<div class="label-content"><span>{{"shipments_history.site" | translate}}: </span><p *ngIf="siteInfo.name">{{ siteInfo.name }}</p> | <p *ngIf="siteInfo.address">{{ siteInfo.address }}</p></div>
			<div class="label-content"><span>{{"warnings.period" | translate}}: </span><p>{{ selectedPeriodFormatted }}</p></div>
		</div>
	</div>

	<div class="battery-count">
		<div class="d-flex align-items-center justify-content-around">
			<mat-icon svgIcon="truck" class="icon"></mat-icon>
			<span class="count">{{ totalTrucks }}</span>
		</div>
		<div class="total">Total Trucks</div>
	</div>
</div>
